import { SeguridadService } from 'src/app/services/seguridad.service';
import { Global } from '../../../global';
import { FormGroup } from '@angular/forms';

export class ProcesoReporte {
    private _seguridad = new SeguridadService();
    private _prefixPage: string = 'pages';
    private _objSession = {
        severity: 'error',
        summary: 'Sesión Expirada',
        detail: 'Lo vamos a redirigir para volver a ingresar',
    };
    private _routerLogout = ['auth', 'logout'];
    private _items: Record<string, any>[] = [];
    // Lista de columnas a mostar
    private _columns: Record<string, any>[];
    // nombre de la tabla
    private _recordName: string;
    // nombre en singular del item
    private _name: string;
    // nombre en plural del item
    private _pluralName: string;
    // total de registros
    private _totalRecords: number = 0;
    // para la carga de regitros
    private _loading: boolean = false;
    private _navigate: string[];

    private _objClassOnLista: any;
    private _serviceOnLista: any;
    private _tituloOnLista: string;
    private _columnasOnLista: Record<string, any>[] = [];
    private _filters: Record<string, any>[] = [];
    private _showOnLista: boolean = false;
    private _recordNameOnLista: string;

    private _formGroup: FormGroup;

    constructor() {}

    get currentUser() {
        return this._seguridad.getCurrentUser();
    }

    get prefixPage() {
        return this._prefixPage;
    }

    get objSession() {
        return this._objSession;
    }

    get routerLogout() {
        return this._routerLogout;
    }

    get prefix() {
        return Global.PREFIX_RECORD;
    }

    set items(items: Record<string, any>[]) {
        this._items = items;
    }
    get items(): Record<string, any>[] {
        return this._items;
    }

    set columns(columns: Record<string, any>[]) {
        this._columns = columns;
    }
    get columns(): Record<string, any>[] {
        return this._columns;
    }

    set recordName(recordName: string) {
        this._recordName = `${Global.PREFIX_RECORD}.${recordName}`;
    }
    get recordName() {
        return this._recordName;
    }

    set name(name: string) {
        this._name = name;
    }
    get name(): string {
        return this._name;
    }

    set pluralName(pluralName: string) {
        this._pluralName = pluralName;
    }
    get pluralName(): string {
        return this._pluralName;
    }

    set totalRecords(totalRecords: number) {
        this._totalRecords = totalRecords;
    }
    get totalRecords(): number {
        return this._totalRecords;
    }

    set loading(loading: boolean) {
        this._loading = loading;
    }
    get loading(): boolean {
        return this._loading;
    }

    set navigate(navigate: string[]) {
        this._navigate = navigate;
    }
    get navigate() {
        return this._navigate;
    }

    set filters(filters: Record<string, any>[]) {
        this._filters = filters;
    }
    get filters(): Record<string, any>[] {
        return this._filters;
    }

    set serviceOnLista(serviceOnLista: any) {
        this._serviceOnLista = serviceOnLista;
    }
    get serviceOnLista() {
        return this._serviceOnLista;
    }

    set tituloOnLista(tituloOnLista: string) {
        this._tituloOnLista = tituloOnLista;
    }
    get tituloOnLista() {
        return this._tituloOnLista;
    }

    set columnasOnLista(columnasOnLista: Record<string, any>[]) {
        this._columnasOnLista = columnasOnLista;
    }
    get columnasOnLista(): Record<string, any>[] {
        return this._columnasOnLista;
    }

    set objClassOnLista(objClassOnLista: any) {
        this._objClassOnLista = objClassOnLista;
    }
    get objClassOnLista() {
        return this._objClassOnLista;
    }

    set showOnLista(showOnLista: boolean) {
        this._showOnLista = showOnLista;
    }
    get showOnLista(): boolean {
        return this._showOnLista;
    }

    set recordNameOnLista(recordNameOnLista: string) {
        this._recordNameOnLista = `${Global.PREFIX_RECORD}.${recordNameOnLista}`;
    }
    get recordNameOnLista(): string {
        return this._recordNameOnLista;
    }

    set formGroup(formGroup: FormGroup) {
        this._formGroup = formGroup;
    }
    get formGroup(): FormGroup {
        return this._formGroup;
    }

    invalidControl(name: string) {
        return (
            this._formGroup.get(name)?.invalid &&
            this._formGroup.get(name)?.touched
        );
    }

    invalidControlDetalle(fg: FormGroup, name: string) {
        return fg.get(name)?.invalid && fg.get(name)?.touched;
    }

    async setInvalidControlsDetalle(fg: FormGroup) {
        Object.keys(fg.controls).forEach((key) => {
            fg.controls[key].markAsDirty();
            fg.controls[key].markAsTouched();
        });
    }

    async onLista(
        service: any,
        clase: any,
        title: string,
        filters: Record<string, any>[] = []
    ) {
        this._serviceOnLista = service;
        this._objClassOnLista = clase;
        this._tituloOnLista = title;
        this._columnasOnLista = clase.columsOnLista;
        this.recordNameOnLista = clase.RECORD_NAME;
        this._showOnLista = true;
        this._filters = filters;
    }

    async cerrarOnLista(obj?: Record<string, any>) {
        this._serviceOnLista = null;
        this._columnasOnLista = [];
        this._tituloOnLista = '';
        this._showOnLista = false;
        this._filters = [];
    }

    async getFiltroEmpresa() {
        let filtros = [];
        if (this.formGroup.value?.id_empresa) {
            filtros.push({
                field: 'id_empresa',
                value: this.formGroup.value.id_empresa,
                type: 'id',
            });
        }
        return filtros;
    }

    async getIdAdmin() {
        let id_admin = null;
        const empresa = this.currentUser.empresa;
        if (empresa.autogestion && empresa.id !== empresa.id_admin) {
            id_admin = empresa.id;
        }
        return id_admin;
    }
}
